/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Report.css';
import banner from './banner.png';
import cx from 'classnames';
import img1 from './1.jpg'
import img2 from './2.jpg'
import img3 from './3.jpg'
import img4 from './4.jpg'
import img5 from './5.jpg'
import img6 from './6.jpg'
import img7 from './7.jpg'
import img8 from './8.jpg'
import img9 from './9.jpg'



const data=[
  {
    tit:'网易云音乐抱腿阿里爸爸，京东总榜冲前十 ▍『数字品牌榜』严肃周报',
    info:'作为人生赢家，莫过于刘强东爱情事业双丰收了吧……',
    time:'2018-03-13',
    imgUrl:`${img1}`,
    href:'https://mp.weixin.qq.com/s?__biz=MzI0MjY0OTE0MQ==&mid=2247484102&idx=1&sn=62c9e5bd92bdcf112a69a6f173f46aca&chksm=e978539cde0fda8a4b1428e04b95cc19522c9c96d967d1cc16dc3d79951cfe37c662e1ae5c34#rd'
  },{
    tit:'统一、康师傅、旺旺、徐福记：台湾快消品牌春节假日营销榜 ▍『数字品牌榜』严肃报告',
    info:'谁的春节过得好？',
    time:'2018-03-06',
    imgUrl:`${img2}`,
    href:'https://mp.weixin.qq.com/s?__biz=MzI0MjY0OTE0MQ==&mid=2247484087&idx=1&sn=9037f1574cc4c78e6117c30fd6624850&chksm=e97853edde0fdafb17a874c13b953b2bec4b44eb1f394d51286c432384804f49c7b0103d9ba6#rd'
  },{
    tit:'有人上天，有人跌地，还有人关门大吉……春节品牌新鲜事大盘点 ▍『数字品牌榜』严肃月报',
    info:`微信榜看点：回家过年典范<br/>微博榜看点：为你诠释明星效应<br/>今日头条看点：这是汽车头条吧？<br/>知乎榜看点：你有春晚，我有故事会`,
    time:'2018-03-05',
    imgUrl:`${img3}`,
    href:'https://mp.weixin.qq.com/s?__biz=MzI0MjY0OTE0MQ==&mid=2247484080&idx=1&sn=0a1df9ccdf1686abea52ada22ec5fb8a&chksm=e97853eade0fdafc551f7ab1c0017931bbd5e8f61a466183d5fef8ded8c1edab74ccd8c73382#rd'
  }, {
    tit:'专业做鸡的肯德基没鸡了？▍『数字品牌榜』严肃分析',
    info:'去吃金拱门的大鸡排啊~',
    time:'2018-02-27',
    imgUrl:`${img4}`,
    href:'https://mp.weixin.qq.com/s?__biz=MzI0MjY0OTE0MQ==&mid=2247484072&idx=1&sn=a38e690240df97acf9a8d066e7be2f0e&chksm=e97853f2de0fdae4bde65703e9158a13b6bc58214d9a36cb80e93a34bfa4d1f7f77b9295fd7c#rd'
  },{
    tit:'李宁：日落西山你不陪，东山再起你是谁 ▍『数字品牌榜』严肃分析',
    info:'中国李宁，请多指教',
    time:'2018-02-26',
    imgUrl:`${img5}`,
    href:'https://mp.weixin.qq.com/s?__biz=MzI0MjY0OTE0MQ==&mid=2247484067&idx=1&sn=33be6d9918f84287195c372899e3f69b&chksm=e97853f9de0fdaef18ac98f9c164e076abb08e883f0544e2723213f93e9cd1d5125e88ba2569#rd'
  }, {
    tit:'A站的一生 ▍『数字品牌榜』严肃分析',
    info:'眼看它高楼起，眼看它楼塌了',
    time:'2018-02-09',
    imgUrl:`${img6}`,
    href:'https://mp.weixin.qq.com/s?__biz=MzI0MjY0OTE0MQ==&mid=2247484057&idx=1&sn=45c95872d60c522e087f2a52168ddd24&chksm=e97853c3de0fdad5ea31f880df5648c7f19f2384d46fb12aa4e52d308e4952573e7fd220bb78#rd'
  },{
    tit:'转化率不公平！百雀羚长图种草有多成功？ ▍『数字品牌榜』严肃分析',
    info:'关于这场著名刷屏传播事件的争论，现在可以结案了。',
    time:'2018-02-07',
    imgUrl:`${img7}`,
    href:'https://mp.weixin.qq.com/s?__biz=MzI0MjY0OTE0MQ==&mid=2247484047&idx=1&sn=3e105f509c8d5107ada40234cf6a1d9c&chksm=e97853d5de0fdac38d64f93d58c2798734f63ef220efd1375628e58a02727f181e2c64ddba69#rd'
  }, {
    tit:'小鲜肉助力迪奥，海澜之家抱大粗腿 ▍『数字品牌榜』严肃周报',
    info:'上周号外：苹果广告《三分钟》刷屏啦！',
    time:'2018-02-06',
    imgUrl:`${img8}`,
    href:'https://mp.weixin.qq.com/s?__biz=MzI0MjY0OTE0MQ==&mid=2247484042&idx=1&sn=6c6359111c6e6804074574e7e62f945b&chksm=e97853d0de0fdac6c0d28493db784e217a9cb8e1d1f9f9e0baa315970477780ab58a903b4cbf#rd'
  }, {
    tit:'网易“有态度”有多管用？▍『数字品牌榜』严肃分析',
    info:'中国最好的乐评人来自网易云音乐；最好的段子手来自网易新闻……',
    time:'2018-01-31',
    imgUrl:`${img9}`,
    href:'https://mp.weixin.qq.com/s?__biz=MzI0MjY0OTE0MQ==&mid=2247484033&idx=1&sn=8a183a18d68f4f9c4e9b011f5d59fe0b&chksm=e97853dbde0fdacdad3e08efda969c59fe4eabbb5447dd7c1e593f86b263bc01a6cdd1e891b7#rd'
  }
]


const  styleType=[
  [`${cx(s.item1, s.fl)}`,`${s.item1Img}`,`${s.item1Line}`,`${s.item1List}`],
  [`${cx(s.item2, s.fr)}`,`${s.item2Img}`,`${s.item2Line}`,`${s.item2List}`],
  [`${cx(s.item2, s.fl)}`,`${s.item2Img}`,`${s.item2Line}`,`${s.item2List}`],
  [`${cx(s.item2, s.fl, s.maginLeft)}`,`${s.item2Img}`,`${s.item2Line}`,`${s.item2List}`],
  [`${cx(s.item2, s.fr)}`,`${s.item2Img}`,`${s.item2Line}`,`${s.item2List}`],
  [`${cx(s.item2, s.fl)}`,`${s.item2Img}`,`${s.item2Line}`,`${s.item2List}`],
  [`${cx(s.item1, s.fr)}`,`${s.item1Img}`,`${s.item1Line}`,`${s.item1List}`],
  [`${cx(s.item1, s.fl)}`,`${s.item1Img}`,`${s.item1Line}`,`${s.item1List}`],
  [`${cx(s.item2, s.fr)}`,`${s.item2Img}`,`${s.item2Line}`,`${s.item2List}`],
  
]



class Report extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired
  };

  render() {
    return (
      <div className={s.clearfix}>
        {/* <div className={s.banner}><img src={banner}/></div>  */}
        <div className={s.imgBox}>

          <div className={s.banner}></div>
        </div>

        <div className={s.content}>
          {/* <div className={s.reportHead}>
            <div className={s.fl}>
              <span className={s.reprotTit}>研究报告</span>
              <span className={s.titEn}>Reports</span>
            </div>
            <div className={s.sea}>
              <input type="text" name="" id="" value="" className={s.reportSea} />
              <i className={s.seaIco}></i>
            </div>
          </div> */}
          <div className={s.reportCon}>
            <div className={s.fl}></div>

            {data.map((i,index)=>
              <a key={index} className={styleType[index][0]} href={i.href} target='_blank'>
                <div className={styleType[index][1]}><img src={i.imgUrl} /></div>
                <span className={styleType[index][2]}></span>
                <div className={styleType[index][3]}>
                  <span className={s.itemTit}>{i.tit}</span>
                  <span className={s.itemCon} dangerouslySetInnerHTML={{__html:i.info}} />
                  {/* <span className={s.itemWriter}>名称</span> */}
                  <span className={s.itemTime}>{i.time}</span>
                </div>
              </a>
            )}

          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Report);



// WEBPACK FOOTER //
// src/routes/report/Report.js